import type { TacticalFeature } from "@/services/tactical.service";

const STROKE = "#dc2626";

/** Локальная GeoJSON-фича для offline create (temp id < 0). */
export function buildOptimisticFeature(
  tempId: number,
  data: Record<string, unknown>,
): TacticalFeature {
  const kindRaw = String(data.kind ?? "point");
  const kind =
    kindRaw === "line" || kindRaw === "polygon" || kindRaw === "text" || kindRaw === "point"
      ? kindRaw
      : "point";
  const label = typeof data.label === "string" ? data.label : "";
  let geometry: TacticalFeature["geometry"];
  if (kind === "line" && Array.isArray(data.coordinates)) {
    geometry = {
      type: "LineString",
      coordinates: data.coordinates as [number, number][],
    };
  } else if (kind === "polygon" && Array.isArray(data.coordinates)) {
    const ring = data.coordinates as [number, number][];
    const closed =
      ring.length > 0 &&
      (ring[0]![0] !== ring[ring.length - 1]![0] || ring[0]![1] !== ring[ring.length - 1]![1])
        ? [...ring, ring[0]!]
        : ring;
    geometry = { type: "Polygon", coordinates: [closed] };
  } else {
    geometry = {
      type: "Point",
      coordinates: [Number(data.lng), Number(data.lat)],
    };
  }
  const stroke = String(data.stroke_color ?? STROKE);
  return {
    type: "Feature",
    id: tempId,
    geometry,
    properties: {
      id: tempId,
      kind,
      source: kind === "text" ? "text" : "sketch",
      legendKey: `tactical:offline:${tempId}`,
      name: label || "Offline",
      iconUrl: "",
      sizePx: Number(data.size_px ?? 32),
      rotationDeg: Number(data.rotation_deg ?? 0),
      strokeColor: stroke,
      strokeWidth: Number(data.stroke_width ?? 2),
      strokeDash: "solid",
      fillColor: String(data.fill_color ?? stroke),
      fillOpacity: Number(data.fill_opacity ?? 0.25),
      label,
      symbolKlsId: (data.symbol_kls_id as number | undefined) ?? null,
      symbolSidc: "",
      isLocked: false,
      effectivelyLocked: false,
      isVisible: true,
      effectivelyVisible: true,
      revision: 1,
    },
  };
}
